module.exports = __webpack_public_path__ + "img/footer.3278f630.png";